import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";

"use strict";
ko.bindingHandlers.sidebar = {
    "init":function(elt, va, allbindings, model, context) {
        console.log("sidebar:", arguments);
        var innerBindingContext = context.extend(va);
        ko.applyBindingsToDescendants(innerBindingContext, elt);
        $(elt).removeClass("loader");
        return { controlsDescendantBindings: true };
    }
};
